import { FunctionalInterfaceInstanceReply } from "@/backend/express/controllers/functionalInterfaceInstances/functionalInterfaceInstanceController";
import { Client } from "./client";

export class FunctionalInterfaceInstanceController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async readFunctionalInterface(id: string): Promise<FunctionalInterfaceInstanceReply> {
    return this.client.read(`/api/functional-interface-instances/${id}`);
  }
}
